<template>
  <v-card>
    <v-card-text>
      <v-row no-gutters>
        <v-icon size="120">mdi-folder</v-icon>
      </v-row>
      <v-row no-gutters>
        <v-col sm="12">
          <strong class="mr-2">Name:</strong> <span>{{ directory.name }}</span>
        </v-col>
        <v-col sm="12">
          <strong class="mr-2">Type:</strong> <span>{{ directory.type }}</span>
        </v-col>

        <v-col sm="12">
          <v-row no-gutters class="mt-2">
            <v-spacer></v-spacer>
            <v-btn small color="error" @click="confirmDelete">
              delete
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { deleteMediaDirectory } from '@/graphql/media.gql'
import swal from 'sweetalert2'

export default {
  name: 'MediaDirectoryPreview',
  props: {
    directory: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    mutationLoading: false
  }),
  methods: {
    confirmDelete() {
      swal({
        title: 'Are you sure?',
        text:
          'Deleting this folder will affect all content using the files inside.',
        type: 'warning',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          this.deleteDirectory()
        }
      })
    },
    deleteDirectory() {
      this.mutationLoading = true

      this.$apollo
        .mutate({
          mutation: deleteMediaDirectory,
          variables: {
            data: {
              path: this.directory.path,
              name: this.directory.name
            }
          }
        })
        .then(data => {
          let response = data.data.deleteMediaDirectory

          this.handleGraphQLSuccess(response.message)

          this.dialog = false

          this.$emit('deleted')

          this.mutationLoading = false
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          this.mutationLoading = false
        })
    }
  }
}
</script>
